/**
 * ROTAS69 — keep a freshly opened cart-drawer accordion in view.
 *
 * The note and discount accordions are the last thing in the drawer's scroll flow, directly above
 * the pinned total + checkout block. Opening one grows the content downwards, so the panel that
 * just appeared (the discount input) lands underneath that pinned block, out of sight — you had to
 * scroll again to reach the field you just asked for.
 *
 * The lower edge of the readable area is the summary's own top edge, whether it is stuck over the
 * bottom of the scrollport or resting at its natural place at the end of the flow — so that is what
 * the panel is measured against, and the drawer's scroller is nudged by the difference. Deliberately
 * not `scrollIntoView`: that walks every scroll ancestor, and the page behind an open drawer is
 * scroll-locked but still programmatically scrollable.
 *
 * The nudge follows the expansion frame by frame rather than waiting for it, so the panel appears
 * to push the view along instead of jumping once it has settled.
 */
(function () {
  // The drawer snippet is re-rendered by the Section Rendering API on every cart change, so guard
  // against binding the delegated listener a second time.
  if (window.__r69CartReveal) return;
  window.__r69CartReveal = true;

  var SCROLLER = '.cart-drawer__content';
  var GAP = 12;
  var MAX_FOLLOW_MS = 700;

  /**
   * @param {HTMLDetailsElement} details
   */
  function follow(details) {
    var scroller = details.closest(SCROLLER);
    var summary = scroller && scroller.querySelector('.cart-drawer__summary');
    if (!scroller || !summary) return;

    var body = details.querySelector('.details-content');
    var done = false;
    var end = function () {
      done = true;
    };
    if (body) body.addEventListener('transitionend', end, { once: true });

    var started = performance.now();
    var step = function () {
      var hidden = details.getBoundingClientRect().bottom + GAP - summary.getBoundingClientRect().top;
      if (hidden > 0) scroller.scrollTop += hidden;

      if (!done && performance.now() - started < MAX_FOLLOW_MS) {
        requestAnimationFrame(step);
      } else if (body) {
        body.removeEventListener('transitionend', end);
      }
    };
    requestAnimationFrame(step);
  }

  // `toggle` does not bubble, so listen in the capture phase — it still travels down to the target.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      if (!details.closest(SCROLLER)) return;
      follow(details);
    },
    true
  );
})();
